// extracted by mini-css-extract-plugin
export default {"sidebar":"Faq_sidebar__xT2so","section":"Faq_section__RM3Ue","heading":"Faq_heading__0z1k8","button":"Faq_button__qcbR3","active":"Faq_active__ayePj","test":"Faq_test__2hSV2"};